export const DEFAULT_FLUSH_MS = 20000;
export const MIN_FLUSH_MS = 5000;
export const RECONNECT_BACKOFF_MS = 5000;
export const MAX_SNAPSHOT_ORDERS = 100;
